import { Button, Icon, Text } from '@scale/scaleui-radix';
import { Link } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

const RedirectButtonLink = ({ destinationUrl, text }: { destinationUrl: string; text: string }) => {
  return (
    <Button size="2" variant="ghost" color="neutral" radius="small" className="w-fit" asChild>
      <Link to={destinationUrl}>
        <Icon icon={faArrowLeft} label="back" />
        <Text>{text}</Text>
      </Link>
    </Button>
  );
};

export default RedirectButtonLink;
